import React, {useEffect, useState} from 'react';
import {useSelector, useDispatch} from 'react-redux';
import {View, Text, ActivityIndicator, FlatList, ScrollView} from 'react-native';
import styled from 'styled-components/native';
import AsyncStorage from "@react-native-async-storage/async-storage";
import useLocalNotification from "../hooks/localNotificationHandler";
import {
    WorkoutsParent,
    WorkoutContainerText,
    WorkoutTextHeader,
    CerebrocoreCommonTextComponent,
    WorkoutContainerHeaderThree,
    WorkoutCommonButton
} from '../styles/common-styles';
function DebugPage() {

    const {
        getAllScheduledNotifications, 
    } = useLocalNotification();

    const [notificationMessages, setNotificationMessages] = useState([]);
    const [notificationGroups, setNotificationGroups] = useState();

    useEffect(() => {
        const gatherDebugInformation = async () => {
            const localNotifs = await getAllScheduledNotifications();
            setNotificationMessages(localNotifs);
        }
        gatherDebugInformation();
    }, []);


    return (
        <DebugContainer>
            <ScrollView>
                <WorkoutContainerHeaderThree>Current Notification Messages</WorkoutContainerHeaderThree>
                <FlatList data={notificationMessages} renderItem={({item}) => <WorkoutContainerText style={{marginTop:15}}>{item.identifier}{"\n"}{item.trigger.dateComponents.weekday} {item.trigger.dateComponents.hour}:{item.trigger.dateComponents.minute}{"\n"}{item.content.body}</WorkoutContainerText>}/>
            </ScrollView>
        </DebugContainer>
    );
}

export const DebugContainer = styled.View`
  width: 100%;
  height: 100%;
  padding:25px;
`;

export default DebugPage;
